import { render, staticRenderFns } from "./genericReport.vue?vue&type=template&id=638b10c3"
import script from "./genericReport.vue?vue&type=script&lang=js"
export * from "./genericReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports